<script>
import axios from "axios";
import API from "@/services/API.js";
import Button2 from "@/components/ui/Button2.vue";
import ChannelForm from "./ChannelForm.vue";
import Alert from "../../alert/Alert.vue";

export default {
  name: "ChannelNew",
  components: {
    Button2,
    ChannelForm,
    Alert,
  },
  props: {
    watchmanId: {
      type: Number,
    },
  },
  data() {
    return {
      channel: {},
      error: null,
      isSubmitted: false,
    };
  },
  methods: {
    saveChannel: function (watchmanId, channel) {
      this.isSubmitted = true;
      axios
        .post(API.route(API.endpoints.channels.add), {
          watchmen_id: watchmanId,
          ...channel,
        })
        .then((response) => {
          if (response.data) {
            this.$emit("onSave", response.data);
          }
        })
        .catch((error) => {
          this.error = error;
          console.error("🐝", error);
          this.isSubmitted = false;
        });
    },
  },
};
</script>

<template>
  <div>
    <div v-if="!channel">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">{{ $t("global.loading") }}</span>
      </div>
    </div>
    <div v-else>
      <ChannelForm v-model="channel" class="mb-4" />
      <div
        class="d-flex pt-3"
        style="gap: 1rem; justify-content: flex-end; margin-bottom: -1rem"
      >
        <Button2
          @click.native.prevent="saveChannel(watchmanId, channel)"
          :disabled="!channel.value || isSubmitted"
        >
          <span
            v-if="isSubmitted"
            class="spinner-border spinner-border-sm ml-2"
            role="status"
            :aria-label="$t('global.loading')"
          ></span>
          {{ $t("global.save") }}
        </Button2>
      </div>
    </div>
    <div v-if="error">
      <div class="alert alert-danger">
        <pre>{{ JSON.stringify(error, null, 2) }}</pre>
      </div>
    </div>
  </div>
</template>
